import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BaseControl, TypeChecker } from '../../../shared';

@Component({
  selector: 'form-label-control',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="typeChecker.isLabel(control)" class="w-full py-3">
      <div [ngClass]="control.fontSize">{{control.label}}</div>
    </div> 
  `,
  styles: `
    :host {
      display: contents;
    }
  ` 
})
export class LabelControlComponent {
  @Input() control !: BaseControl<any>;
  
  typeChecker = TypeChecker;
}
